/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import { CardContent, Typography, Button, Box, Grid, Chip, Stack, Tooltip } from "@mui/material";
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@mui/styles';
import SchoolIcon from "@mui/icons-material/School";
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";
import BackgroundImg from '../../assets/logo/background.svg';
import BackgroundImgNeet from '../../assets/Images/NEET_Assess11.png';
import { languagecodevalue, openSubscriptionModal, setOpenSubscriptionModalDetails, openSnackbar, setSubscribedCourses, ComingFrom, ComingFromSub } from '../../store/reducer';
import trialAndStripeSubscriptionService from '../../services/trialAndStripeSubscriptionService';

export default function SatCard(props) {
  const userRole = useSelector((state) => state.userInfo && state.userInfo.role);
  const dispatch = useDispatch()
  const classes = useStyles();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false)
  const userInfo = useSelector((state) => state.userInfo && state.userInfo);
  const [, forceTick] = useState(0);

 const toUTCDate = (raw) => {
  if (raw === null || raw === undefined || raw === '') return null;

  if (typeof raw === 'number') return new Date(raw);
  if (raw instanceof Date) return raw;

  const str = String(raw).trim();
  if (/Z$|[+-]\d{2}:?\d{2}$/.test(str)) {
    const parsed = new Date(str);
    if (Number.isNaN(parsed.getTime())) {
      console.error('[SatCard] Failed to parse scheduled datetime:', raw);
      return null;
    }
    return parsed;
  }

  const SOURCE_TZ_OFFSET = '+05:30'; 
  const parsed = new Date(`${str.replace(' ', 'T')}${SOURCE_TZ_OFFSET}`);

  if (Number.isNaN(parsed.getTime())) {
    console.error('[SatCard] Failed to parse scheduled datetime:', raw);
    return null;
  }
  return parsed;
};

   const scheduledFromDatetimeuser = props.data?.scheduled_from_datetime;
    const scheduledToDatetimeuser = props.data?.scheduled_to_datetime;


  const getAssessmentStatus = () => {
    const scheduledFromDatetime = props.data?.scheduled_from_datetime;
    const scheduledToDatetime = props.data?.scheduled_to_datetime;
    if (!scheduledFromDatetime || !scheduledToDatetime) {
      return {
        status: "ACTIVE",
        label: "Start Now",
        disabled: false,
      };
    }

    const now = new Date();
    const start = toUTCDate(scheduledFromDatetime);
    const end = toUTCDate(scheduledToDatetime);

    if (now < start) {
      const diff = start - now;

      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
      const minutes = Math.floor((diff / (1000 * 60)) % 60);
      const seconds = Math.floor((diff / 1000) % 60);

      let label = "";

      if (days > 0) {
        label = `Starts in ${days}d ${hours}h ${minutes}m`;
      } else if (hours > 0) {
        label = `Starts in ${hours}h ${minutes}m ${seconds}s`;
      } else if (minutes > 0) {
        label = `Starts in ${minutes}m ${seconds}s`;
      } else {
        label = `Starts in ${seconds}s`;
      }

      return {
        status: "UPCOMING",
        label,
        disabled: true,
      };
    }

    if (now > end) {
      return {
        status: "EXPIRED",
        label: "Expired",
        disabled: true,
      };
    }

    return {
      status: "ACTIVE",
      label: "Start Now",
      disabled: false,
    };
  };
  const assessmentStatus = getAssessmentStatus();
  
 useEffect(() => {
  if (assessmentStatus.status !== "UPCOMING") return;
  console.log('Interval started, status:', assessmentStatus.status);
  const interval = setInterval(() => {
    forceTick((t) => t + 1);
  }, 1000);
  return () => clearInterval(interval);
}, [assessmentStatus.status]);

  function convertComplexity(level) {
    switch (level.toLowerCase()) {
      case 'easy':
        return 'Beginner';
      case 'medium':
        return 'Intermediate';
      case 'hard':
        return 'Advanced';
      default:
        return level;
    }
  }




  const handleClickTrialButton = async (planId, enrollmentType, assessmentId, details) => {
    setLoading(true)
    const body = {
      name: details.title,
      description: details.short_description,
      SATtype: details.type,
      level: convertComplexity(details.complexity_level)
    }
    try {
      const res = await trialAndStripeSubscriptionService.postTrialAssessmentEnrollmentDetails(
        JSON.stringify({ planId, enrollmentType, assessmentId, authUserId: userInfo.id, body })
      );
      if (res.ok) {
        setLoading(false)
        dispatch(openSnackbar(`Subscribed to ${details?.title} Successfully.`));
        handleStartSat();
        // const data = {
        //   id: props?.assessment_details?.id,
        //   // from:location.state?.from
        // }
        // navigate("/auth/AssessmentOverview", { state: data})
        // navigate("/auth/AssessmentOverview", { state: assessmentDetails?.assessment_details?.id })
      }
    } catch (error) {
      setLoading(false)
      console.log(error);
    }
  };


  const handleStartSat = () => {
    if (userRole === 'AUTH_USER') {
      dispatch(languagecodevalue('en'))
      navigate(`/app/assessment/${encodeURIComponent(props?.data?.title)}/${props?.data?.id}`, {
        state: {
          id: props?.data?.id,
          from: "SAT",
          data: props?.data
        }
      });
    }
    else {
      dispatch(languagecodevalue('en'))

      navigate(`/auth/assessment/${encodeURIComponent(props?.data?.title)}/${props?.data?.id}`, {
        state: {
          id: props?.data?.id,
          from: "SAT",
          data: props?.data
        }
      });
    }
  }

  return (
    <Box style={{
      borderRadius: '8px', overflow: 'hidden', maxWidth: '95%',
      boxShadow: '0px 3px 1px -2px rgba(145, 158, 171, 0.2),0px 2px 2px 0px rgba(145, 158, 171, 0.14),0px 1px 5px 0px rgba(145, 158, 171, 0.12)'
    }}>
      {/* <Grid container spacing={2} sx={{marginRight: 2}} 
      style={{    justifyContent: 'center', width: '100%', marginLeft: 0, marginRight: 0}}
      // style={{justifyContent: userRole === 'AUTH_USER' ? 'center' : ""}}
      >
        <Grid className={classes.CardView} item xs={12} sm={6} md={4} lg={3} xl={3} sx={{
          borderRadius: 3, boxShadow: 4, paddingLeft: "0px !important",
          paddingTop: "0px !important", overflow: 'hidden'
        }}> */}

      <Box className={classes.CardViewBackground}
        sx={{
          background: props.data?.image_name
            ? `url(${props.data.image_name}) center / cover no-repeat`
            : props.data?.type === "NEET"
              ? `url(${BackgroundImgNeet}) center / cover no-repeat`
              : "linear-gradient(to right, #6C63FF, #AB47BC)",
          // background: "linear-gradient(to right, #6C63FF, #AB47BC)",
          p: 3,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          position: "relative",
          height: '160px'

        }}
      >
        {!props.data?.image_name && (
          <SchoolIcon sx={{ fontSize: 40, color: "white" }} />
        )}
        {(userRole === 'AUTH_USER') ? null : (
          <Box
            sx={{
              position: "absolute",
              top: 10,
              right: 10,
              backgroundColor: "#6A3FE9",
              color: "white",
              padding: "3px 8px !important",
              fontSize: 12,
              fontWeight: "bold",
              borderRadius: 1,
              // textDecoration: "line-through",
            }}
          >
            <Typography component="span" sx={{ textDecoration: "line-through", mr: 0.5, color: "#dddddd" }}>
              $49.99
            </Typography>
            <Typography component="span" sx={{ textDecoration: "none", color: "#fff" }}>
              Free
            </Typography>
          </Box>
        )}
      </Box>

      {/* Content */}
      <CardContent sx={{ padding: "15px 12px" }}>
        <Stack direction="row" spacing={1} mb={1}>
          <Chip label="Beginner" size="small" sx={{
            background: '#c6f3d4', color: "#003d15",
            borderRadius: '2px', fontWeight: '500',
            textTransform: 'capitalize'
          }} />
          <Chip label={props.data?.type} size="small" sx={{
            background: '#dbeafe', color: "#2b87ff",
            borderRadius: '2px', fontWeight: '500'
          }} />
          {props.data?.scheduled_from_datetime && props.data?.scheduled_to_datetime && (
            <Chip label="Scheduled" size="small" sx={{
              background: '#fef3c7', color: "#92400e",
              borderRadius: '2px', fontWeight: '500'
            }} />
          )}
        </Stack>
        {props.data?.title?.length > 25 ?
          (<Tooltip title={props.data?.title} arrow>
            <Typography variant="h6" fontWeight="bold" id="TitleName">
              {props.data?.title}
            </Typography>
          </Tooltip>)
          :
          (<Typography variant="h6" fontWeight="bold" id="TitleName">
            {props.data?.title}
          </Typography>)
        }

        <Typography className={classes.HighlightedSection} variant="body2" color="text.secondary" mt={0.5} sx={{}}>
          {props.data?.highlighted_section}
        </Typography>



        {/* <Box mt={2} display="flex" alignItems="center">
              <Rating value={4} precision={0.5} readOnly size="small" />
              <Typography variant="body2" color="text.secondary" ml={1}>
                4.0 (120 reviews)
              </Typography>
            </Box> */}

        <Box mt={1} display="flex" alignItems="center">
          <PlayCircleOutlineIcon fontSize="small" sx={{ mr: 0.5 }} />
          <Typography variant="body2">No. of Attempts : {scheduledFromDatetimeuser && scheduledToDatetimeuser ? '01': '06'}</Typography>
        </Box>

        <Stack direction="row" spacing={1} mt={3}>

          {loading &&
            <Button
              fullWidth
              loading
              variant="contained"
              sx={{
                borderRadius: "7px",
                height: "38px",
                background: "#437bfc",
                color: "#fff"
              }}
            >
              Please wait
            </Button>
          }
          {
            (!loading && props.data?.is_subscribed) || userRole === 'AUTH_USER' ? (
              <Button fullWidth
                variant="outlined"
                color="primary"
                disabled={assessmentStatus.disabled}
                sx={{
                  borderRadius: "7px",
                  padding: "6px 0 !important",
                  border:
                    assessmentStatus.status === "EXPIRED"
                      ? "1px solid #BDBDBD"
                      : "1px solid rgb(47,105,240)",
                  background:
                    assessmentStatus.status === "EXPIRED"
                      ? "#E0E0E0"
                      : assessmentStatus.status === "UPCOMING"
                        ? "#E0E0E0"
                        : "rgb(47,105,240)",
                  color:
                    assessmentStatus.status === "ACTIVE"
                      ? "#fff"
                      : "#757575",
                  "&:hover": {
                    background:
                      assessmentStatus.status === "ACTIVE"
                        ? "#fff"
                        : "#E0E0E0",
                    color:
                      assessmentStatus.status === "ACTIVE"
                        ? "rgb(47,105,240)"
                        : "#757575",
                    border:
                      assessmentStatus.status === "ACTIVE"
                        ? "1px solid rgb(47,105,240)"
                        : "1px solid #BDBDBD",
                  },
                }}
                onClick={
                  assessmentStatus.status === "ACTIVE"
                    ? handleStartSat
                    : undefined
                }
              >
                {assessmentStatus.label}
              </Button>
              // <Button
              //   fullWidth
              //   variant="outlined"
              //   color="primary"
              //   sx={{
              //     borderRadius: "7px",
              //     padding: '6px 0 !important',
              //     border: '1px solid rgb(47, 105, 240)',
              //     background: "rgb(47, 105, 240)",
              //     color: "#fff",
              //     '&:hover': {
              //       background: "#fff",
              //       color: "rgb(47, 105, 240)",
              //       padding: '6px 0 !important',
              //       border: '1px solid rgb(47, 105, 240)',
              //     },
              //   }} onClick={handleStartSat}>
              //   Start Now
              // </Button>
            ) : null
          }
          {!loading && !props.data?.is_subscribed && userRole !== 'AUTH_USER' && <Button fullWidth variant="contained" color="primary" sx={{
            borderRadius: "7px",
            background: "#437bfc", color: "#fff", height: "38px", '&:hover': {
              background: "#fff",
              color: "#437bfc",
              border: '1px solid #437bfc',
            }
          }} onClick={() => handleClickTrialButton(props?.data?.subscriptionplanid, 'free', props?.data?.id, props?.data)}>
            Subscribe
          </Button>}
        </Stack>
      </CardContent>

      {/* </Grid>
      </Grid> */}
    </Box>
  );
}
const useStyles = makeStyles((theme) => ({
  trial: {
    color: 'white',
    padding: '0px 6px 0px 6px ',
    background: 'grey',
  },
  HighlightedSection: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    webkitLineClamp: '2',
    webkitBoxOrient: 'vertical',
    height: '44px'
  },
  CardView: {
    minWidth: '300px',
    maxWidth: '320px',
    paddingLeft: 0,
    paddingTop: 0,
    marginBottom: "40px",
    marginLeft: "20px",
    '@media (max-width:999px)': {
      marginBottom: '30px',
      marginLeft: "10px",
    },
    '@media (max-width:500px)': {
      maxWidth: '250px !important',
      minWidth: '250px !important',
    }
  },
  // CardViewBackground: {

  // }
  cardDescription: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: '#fff',
    height: '120px'
  },
  shieldDesign: {
    border: '1px solid #c1c1c1',
    background: '#dddddd69',
    borderRadius: '50%',
    padding: '5px',
    height: '33px',
    width: '33px',
  },
  coursetitle: {
    overflow: 'hidden',
    // color: 'black',
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical',
    [theme.breakpoints.down('md')]: {
      overflow: 'auto',
      WebkitLineClamp: 'initial',
      WebkitBoxOrient: 'initial',
    },


  },
  card: {
    border: '0.5px solid #DFDFDF',
    boxShadow: '0px 3px 6px  #0000001A',
    borderRadius: '6px',
    backgroundImage: `url(${BackgroundImg})`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'bottom right',
    // cursor: 'pointer',
    marginTop: '16px',
    marginLeft: '10px',
    width: '95%',
    // width: '85%', // Reduced from 90% to 85%
    // height: 'auto', // You can add this if needed
    // maxHeight: '300px', // Add maxHeight to limit overall card height
  },
  date: {
    marginTop: '15px',
  },
  button: {
    backgroundColor: '#F8F5F4',
    padding: '4px 6px',
    borderRadius: '6px',
    width: 'max-content',
    maxWidth: '165px',
    fontSize: '12px',
    overflow: 'hidden',
    display: 'block',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis'
  },
  title: {
    marginTop: '10px',
    fontWeight: 'bold',
    fontSize: '15px',
  },
  cardTitle: {
    fontWeight: 'bold',
    fontSize: '15px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    '-webkit-line-clamp': 1,
    display: '-webkit-box',
    '-webkit-box-orient': 'vertical',
  },
  cardTitlenew: {
    fontWeight: 'bold',
    fontSize: '15px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    '-webkit-line-clamp': 2,
    display: '-webkit-box',
    '-webkit-box-orient': 'vertical',
    minHeight: '50px',
    maxHeight: '50px',
  },
  logo: {
    boxShadow: '0px 3px 22px #00000029',
    padding: '4px',
    backgroundColor: '#fff',
    borderRadius: '6px',
    marginTop: '10px',
  },
  description: {
    minHeight: '38px',
    fontSize: '0.8rem !important',
    overflow: 'hidden !important',
    fontFamily: 'Inter',
    textOverflow: 'ellipsis',
    '-o-text-overflow': 'ellipsis',
    '-ms-text-overflow': 'ellipsis',
    '-moz-binding': "url('ellipsis.xml#ellipsis')",
    '-ms-webkit-line-clamp': 2,
    '-webkit-line-clamp': 2,
    display: '-webkit-box',
    '-webkit-box-orient': 'vertical',
    '& span': {
      fontSize: '0.8rem !important',
      color: 'black !important',
      backgroundColor: 'unset !important',
      fontFamily: 'Inter !important',
    },
    '& p': {
      '&:nth-child(1)': {
        display: 'block !important',
      },
      '&:nth-child(even)': {
        display: 'none ',
      },
      '&:nth-child(odd)': {
        display: 'none ',
      },
    },
  },
  enrolledUser: {
    backgroundColor: '#EBFFF8',
    borderRadius: '6px',
    padding: '4px 12px',
    fontSize: '12px',
  },
  active: {
    backgroundColor: 'green',
    borderRadius: '6px',
    padding: '4px 12px',
  },
  inActive: {
    backgroundColor: 'yellow',
    borderRadius: '6px',
    padding: '4px 12px',
  },
  Expired: {
    backgroundColor: '#FF8282',
    borderRadius: '6px',
    padding: '4px 12px',
  },
  trialButton: {
    width: 110,
    borderRadius: '6px',
    fontSize: '12px',
    backgroundColor: 'white',
    '@media (max-width: 1400px)': {
      padding: '6px 3px',
      lineHeight: '1',
    },
    '&:hover': {
      backgroundColor: 'white',
    },
    marginRight: '8px',
  },
  // CourseButton: {
  //     width: 110,
  //     color: '#00B673 ! important',
  //     border: '1px solid #00B673 ! important',
  //     borderRadius: '6px',
  //     fontSize: '12px',
  //     // marginLeft: '1rem',
  //     backgroundColor: 'white',
  //     '&:hover': {
  //         backgroundColor: 'white',
  //     },
  // },
  clamptext: {
    '-webkit-line-clamp': 2,
    display: '-webkit-box',
    '-webkit-box-orient': 'vertical',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'normal',
    minHeight: '2.4em',
    lineHeight: '1.2em'
    //    min-height: 2.4em;                 
    //    line-height: 1.2em;  
  },

  CourseButton: {
    width: 110,
    color: '#6a6e6b', // initial text color
    border: '1px solid #6a6e6b', // initial border color
    borderRadius: '6px',
    fontSize: '12px',
    backgroundColor: 'white',
    '&:hover': {
      color: '#00B673', // text color on hover
      border: '1px solid #00B673', // border color on hover
      backgroundColor: 'white',
    },
  },
  subscribeButton: {
    width: 110,
    color: '#00B673 ! important',
    border: '1px solid #00B673 ! important',
    borderRadius: '6px',
    fontSize: '12px',
    // marginLeft: '1rem',
    backgroundColor: 'white',
    '&:hover': {
      backgroundColor: 'white',
    },
  },
}));